import { Database, FolderKanban, LayoutTemplate, Settings as SettingsIcon, Sparkles, Wallet } from 'lucide-react';
import type { NavItem } from 'shared/components/AppShell';
import { paths } from 'shared/routing/paths';

export interface ManagerNavOptions {
  isAdmin: boolean;
  manager: { isSelfServe: boolean } | null;
}

export function getManagerNav({ isAdmin, manager }: ManagerNavOptions): NavItem[] {
  const items: NavItem[] = [{ label: 'Projects', to: paths.manager.projects, icon: FolderKanban }];

  if (isAdmin) items.push({ label: 'Task Templates', to: paths.manager.taskTemplates, icon: LayoutTemplate });

  items.push({ label: 'Datasets', to: paths.manager.datasets, icon: Database });
  items.push({ label: 'Synthetic Data', to: paths.manager.autoTune, icon: Sparkles });

  if (manager && !manager.isSelfServe) items.push({ label: 'Billing', to: paths.manager.billing, icon: Wallet });

  items.push({ label: 'Settings', to: paths.manager.settings, icon: SettingsIcon });
  return items;
}

export const MANAGER_NAV: NavItem[] = getManagerNav({ isAdmin: true, manager: { isSelfServe: false } });
